export const VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES = {
  AUDIO_TEXT_MATCHING_FAILED: 'AUDIO_TEXT_MATCHING_FAILED',
  VIDEO_FACES_MATCHING_FAILED: 'VIDEO_FACES_MATCHING_FAILED',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
};

export const VIDEO_AGREEMENT_VERIFICATION_ERROR_MESSAGES = {
  [VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES.AUDIO_TEXT_MATCHING_FAILED]:
    'Parece que el texto que leíste no coincide con el que se mostraba en pantalla, por favor vuelve a intentarlo.',
  [VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES.VIDEO_FACES_MATCHING_FAILED]:
    'No pudimos confirmar que la persona del reconocimiento facial coincida con la del video acuerdo. Por favor, vuelve a intentarlo.',
  [VIDEO_AGREEMENT_VERIFICATION_ERROR_TYPES.UNEXPECTED_ERROR]:
    'Ocurrió un error al verificar el video acuerdo',
};

export const VIDEO_AGREEMENT_TYPES = {
  IDENTITY_VERIFICATION_VIDEO_AGREEMENT:
    'IDENTITY_VERIFICATION_VIDEO_AGREEMENT',
};
